import apiCall from "./apiCall";

const ajaxMobileMoney = {
  
   async fetchKPIs(data) {
    return await apiCall('platform/webclient/mobile_money_kpis', data);
  },
  async fetchTransactions(data) {
    return await apiCall('platform/webclient/mobile_money_transactions', data);
  },

};

export default ajaxMobileMoney;